export default {"src":"/_next/static/media/Facebook.1f1efc4a.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};